<!-- security policy -->
<div class="container col-xxl-8 px-4 py-5 landing-content" >
    <div class="row align-items-center g-5 py-5">
  
        <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Security Policy</h1>
        <div class="row align-items-center g-5">
          <h2 class="display-5 lh-1 mb-3">1. Introduction</h2>
          <p>We are committed to protecting the security of your information. This Security Policy explains how we safeguard RTK Base data and related telemetry processed by the Service.</p>

          <h2 class="display-5 lh-1 mb-3">2. Data Storage and Purpose</h2>
          <p>We store RTK Base data and related telemetry that you configure for upload solely to provide, maintain, secure, and improve the Service for your account. Default retention is 365 days. You may request deletion at any time. Upon account termination, we delete or anonymize stored data within 30 days unless a longer period is required by law or needed for security/abuse-prevention.</p>

          <h2 class="display-5 lh-1 mb-3">3. Encryption and Transmission</h2>
          <p>Data is encrypted in transit and at rest. Where a client device uses an NTRIP protocol version that does not support encryption in transit (e.g., NTRIP v1), data is encrypted once received by our Service.</p>

          <h2 class="display-5 lh-1 mb-3">4. Backups and Logs</h2>
          <p>We do not back up customer data. We may retain limited access and security logs as appropriate to operate and protect the Service. When retained, such logs are kept for up to 365 days. Object-level logging (e.g., lifecycle deletion records) may be enabled on demand for troubleshooting, security, or legal purposes.</p>

          <h2 class="display-5 lh-1 mb-3">5. Access Controls</h2>
          <p>Access to customer data is limited to authorized personnel under least-privilege principles and subject to audit.</p>

          <h2 class="display-5 lh-1 mb-3">6. Security Incident Notification</h2>
          <p>In the event of a data breach impacting your data, we will notify you without undue delay and no later than 7 days after becoming aware of the incident, consistent with applicable legal requirements.</p>
      </div>

    </div>
  </div>


<!-- Privacy policy -->

<div class="container col-xxl-8 px-4 py-5 landing-content" >
    <div class="row align-items-center g-5 py-5">
  
        <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Privacy Policy</h1>
        <div class="row align-items-center g-5">
          <h2 class="display-5 lh-1 mb-3">1. Introduction</h2>
          <p>This Privacy Policy explains how we collect, use, store, and protect your information while providing the Service.</p>

          <h2 class="display-5 lh-1 mb-3">2. Categories of Data</h2>
          <p>As configured by you, we may process RTK Base data and related telemetry (including coordinates/metadata, timestamps, device identifiers, and account identifiers) to provide the Service.</p>

          <h2 class="display-5 lh-1 mb-3">3. Purpose of Processing</h2>
          <p>We process customer data solely to provide, maintain, secure, and improve the Service for your account.</p>

          <h2 class="display-5 lh-1 mb-3">4. Retention</h2>
          <p>Default retention is 365 days. You may delete data at any time. Upon account termination, we delete or anonymize stored data within 30 days unless retention is required by law or for security/abuse-prevention.</p>

          <h2 class="display-5 lh-1 mb-3">5. Your Rights</h2>
          <p>You may request access to or deletion of your information, and request correction of inaccurate information. We will respond within 30 days in accordance with applicable law.</p>

          <h2 class="display-5 lh-1 mb-3">6. Data Residency and Transfers</h2>
          <p>Your data may be stored and processed in jurisdictions where we or our infrastructure operate, with reasonable safeguards consistent with applicable law.</p>

          <h2 class="display-5 lh-1 mb-3">7. No Sale/Share of Personal Information</h2>
          <p>We do not sell or share personal information as defined under applicable privacy laws.</p>
      </div>
    </div>
  </div>

